import { reisorProDriverRequest } from "../utils/reisorProMarketHttp.js";

function transportError(response, data, fallbackCode) {
  const status = Number(response?.status || 0);
  const code = String(
    data?.error ||
      data?.code ||
      (status ? `HTTP_${status}` : fallbackCode)
  ).trim() || fallbackCode;
  const error = new Error(code);
  error.code = code;
  error.status = status;
  error.payload = data && typeof data === "object" ? data : {};
  return error;
}

async function jsonRequest(path, options, fallbackCode) {
  const { response, data } = await reisorProDriverRequest(path, options);
  if (!response?.ok || data?.ok === false) {
    throw transportError(response, data, fallbackCode);
  }
  return data && typeof data === "object" ? data : {};
}

export function getReisorAiQuota({ token = "", signal } = {}) {
  return jsonRequest(
    "/api/ai/quota",
    { method: "GET", token, signal },
    "AI_QUOTA_FAILED"
  );
}

export function sendReisorAiMessage({ message, conversationId = "", token = "", signal } = {}) {
  return jsonRequest(
    "/api/ai/message",
    {
      method: "POST",
      token,
      signal,
      body: {
        message: String(message || "").trim(),
        ...(conversationId ? { conversationId: String(conversationId) } : {}),
      },
    },
    "AI_MESSAGE_FAILED"
  );
}

export function getReisorAiResultSet({ resultSetId, offset = 0, limit = 20, token = "", signal } = {}) {
  const id = encodeURIComponent(String(resultSetId || "").trim());
  const params = new URLSearchParams({
    offset: String(Math.max(0, Number(offset) || 0)),
    limit: String(Math.max(1, Math.min(100, Number(limit) || 20))),
  });
  return jsonRequest(
    `/api/ai/result-sets/${id}?${params.toString()}`,
    { method: "GET", token, signal },
    "AI_RESULT_SET_FAILED"
  );
}

export function checkDriverSavedFreightSearch({ criteria, token = "", signal } = {}) {
  const params = new URLSearchParams({
    from: String(criteria?.from || "").trim(),
    to: String(criteria?.to || "").trim(),
    truck: String(criteria?.truck || "").trim().toUpperCase(),
    loadingDate: String(criteria?.loadingDate || "").trim(),
  });
  return jsonRequest(
    `/api/driver/freight-market/saved-searches/check?${params.toString()}`,
    { method: "GET", token, signal },
    "DRIVER_SAVED_SEARCH_CHECK_FAILED"
  );
}

export function createDriverSavedFreightSearch({ criteria, token = "", signal } = {}) {
  return jsonRequest(
    "/api/driver/freight-market/saved-searches",
    {
      method: "POST",
      token,
      signal,
      body: {
        from: String(criteria?.from || "").trim(),
        to: String(criteria?.to || "").trim(),
        truck: String(criteria?.truck || "").trim().toUpperCase(),
        loadingDate: String(criteria?.loadingDate || "").trim(),
      },
    },
    "DRIVER_SAVED_SEARCH_CREATE_FAILED"
  );
}

export function getDriverAvailableVehicles({ token = "", signal } = {}) {
  return jsonRequest(
    "/api/driver/available-vehicles",
    { method: "GET", token, signal },
    "DRIVER_AVAILABLE_VEHICLE_LIST_FAILED"
  );
}

export function createDriverAvailableVehicle({
  vehicle,
  token = "",
  signal,
  aiReturnPublish = false,
  aiResultSetId = "",
  aiGuidedPublish = false,
  aiContextId = "",
} = {}) {
  const body = vehicle && typeof vehicle === "object" ? { ...vehicle } : {};
  if (aiReturnPublish) {
    body.aiReturnPublish = true;
    body.aiResultSetId = String(aiResultSetId || "").trim().slice(0, 80);
  }
  if (aiGuidedPublish) {
    body.aiGuidedPublish = true;
    body.aiContextId = String(aiContextId || "").trim().slice(0, 80);
  }
  return jsonRequest(
    "/api/driver/available-vehicles",
    {
      method: "POST",
      token,
      signal,
      body,
    },
    "DRIVER_AVAILABLE_VEHICLE_CREATE_FAILED"
  );
}

export function getReisorProMarketAiQuota({ token = "", signal } = {}) {
  return jsonRequest(
    "/api/market-board/ai/quota",
    { method: "GET", token, signal },
    "AI_QUOTA_FAILED"
  );
}

export function sendReisorProMarketAiMessage({ message, conversationId = "", token = "", signal } = {}) {
  return jsonRequest(
    "/api/market-board/ai/message",
    {
      method: "POST",
      token,
      signal,
      body: {
        message: String(message || "").trim(),
        ...(conversationId ? { conversationId: String(conversationId) } : {}),
      },
    },
    "AI_MESSAGE_FAILED"
  );
}

export function getReisorProMarketAiResultSet({ resultSetId, offset = 0, limit = 20, token = "", signal } = {}) {
  const id = encodeURIComponent(String(resultSetId || "").trim());
  const params = new URLSearchParams({
    offset: String(Math.max(0, Number(offset) || 0)),
    limit: String(Math.max(1, Math.min(100, Number(limit) || 20))),
  });
  return jsonRequest(
    `/api/market-board/ai/result-sets/${id}?${params.toString()}`,
    { method: "GET", token, signal },
    "AI_RESULT_SET_FAILED"
  );
}
